import {Button, IconButton} from '@wandb/components';
import React from 'react';
import {useParams} from 'react-router-dom';

import {usePartMaybe} from '../../state/views/hooks';
import {runColor} from '../../util/colors';
import {getCustomRunName} from '../../util/runs';
import * as urls from '../../util/urls';
import {useSingleRunModeContext} from '../MultiRunWorkspace/SingleRunMode';
import {useWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';
import {useWorkspaceSettingsColorPalette} from '../WorkspaceDrawer/Settings/colorPalette/ColorPalette';
import {useSemanticLegendSettingsContext} from '../WorkspaceDrawer/Settings/semanticLegend/SemanticLegendSettingsContextProvider';
import {useSingleRunBackUrl} from './useSingleRunBackUrl';

export const SingleRunHeader = () => {
  const {run} = useSingleRunModeContext();
  const backUrl = useSingleRunBackUrl();
  const {customRunColorsRef, customRunNamesRef} = useWorkspaceRefsContext();
  const customRunNames = usePartMaybe(customRunNamesRef);
  const customRunColors = usePartMaybe(customRunColorsRef);
  const {semanticLegendSettings, semanticLegendRunColorOptions} =
    useSemanticLegendSettingsContext();
  const colorPaletteOption = useWorkspaceSettingsColorPalette();
  const {entityName, projectName} = useParams<{
    entityName: string;
    projectName: string;
  }>();

  if (!run) {
    return null;
  }

  const runDisplayColor = runColor({
    run,
    customRunColors,
    semanticLegendSettings: {
      ...semanticLegendSettings,
      runColorOptions: semanticLegendRunColorOptions,
    },
    colorPaletteOption,
  });
  const customRunName = getCustomRunName(run.name, false, customRunNames);

  return (
    <header className="mb-16 flex justify-between gap-32">
      <div className="flex gap-12">
        <IconButton
          icon="back"
          aria-label="Exit single-run mode"
          href={backUrl}
        />
        <div
          className="mt-8 h-16 w-16 rounded-full"
          style={{backgroundColor: runDisplayColor}} // cannot use tailwind for dynamic values
        />
        <h2 className="mt-2 flex-1 break-all text-lg font-semibold">
          {customRunName ? (
            <>
              <span>{customRunName} </span>
              <span className="text-sm text-moon-500">({run.displayName})</span>
            </>
          ) : (
            run.displayName
          )}
        </h2>
      </div>
      <Button
        variant="secondary"
        size="md"
        startIcon="list-bullets"
        href={urls.run({
          entityName: entityName,
          projectName: projectName,
          name: run.name,
          tab: 'overview',
        })}>
        View run details
      </Button>
    </header>
  );
};
